import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from "styled-components";
import Link from "next/link";
import { AddToCartComplete } from "@/modules/products/styles/ProductDetail.style";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
const TextWithIconSpan = styled.span.withConfig({
    componentId: "sc-c68da2d-0"
})(_templateObject());
export const AddToCartToast = (param)=>{
    let { type , content , link , addToCartCompleteModal  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsx(Link, {
        href: link,
        children: /*#__PURE__*/ _jsxs(AddToCartComplete, {
            className: "alert-".concat(type, " ").concat(addToCartCompleteModal ? "fadeIn" : "fadeOut"),
            children: [
                /*#__PURE__*/ _jsx(TextWithIconSpan, {
                    children: content
                }),
                /*#__PURE__*/ _jsx(Icon, {
                    icon: ArrowRight,
                    size: Sizes.small,
                    color: theme.new.colors.white
                })
            ]
        })
    });
};
